module.exports = __webpack_public_path__ + "img/service__f1lottery——zh.d04d2590.png";